import { render, staticRenderFns } from "./firebase-test.vue?vue&type=template&id=03622732"
import script from "./firebase-test.vue?vue&type=script&lang=js"
export * from "./firebase-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports